import { ItemSortOptionsEnum } from "modules/tradeLists/model/tradeList";
import type { SortOption as MainbarSortOption } from "modules/common/components/mainbar/types";
import type { SortOption as MobileSortOption } from "modules/common/components/mainbar/MobileSortControls";

/**
 * Unified sort options for trade items across all contexts (LGS, trade lists, city, user trades).
 * This is the single source of truth - all components should import from here.
 */
export const TRADE_ITEM_SORT_OPTIONS: MainbarSortOption<ItemSortOptionsEnum>[] =
  [
    { key: "name", name: "Name", enum: ItemSortOptionsEnum.Name },
    { key: "price", name: "Price", enum: ItemSortOptionsEnum.Price },
    { key: "createdAt", name: "Added", enum: ItemSortOptionsEnum.CreatedAt },
    { key: "updatedAt", name: "Modified", enum: ItemSortOptionsEnum.UpdatedAt },
    { key: "quantity", name: "Quantity", enum: ItemSortOptionsEnum.Quantity },
  ];

/**
 * Mobile-specific sort options that match the desktop options
 * but follow the MobileSortOption interface
 */
export const TRADE_ITEM_SORT_OPTIONS_MOBILE: MobileSortOption<ItemSortOptionsEnum>[] =
  TRADE_ITEM_SORT_OPTIONS.map((option) => ({
    key: option.key,
    name: option.name,
    enum: option.enum,
  }));
